module.exports = __webpack_public_path__ + "static/media/imaginxp-loginbanner-4.8be7a338.jpg";